import React from 'react';
import {Route, IndexRoute} from 'react-router';
import App from './components/App';
import * as PathConstants from './constants/pathConstants';
import LoginPage from './components/authentication/login/LoginPage'; //eslint-disable-line import/no-named-as-default
import UserCreationPage from './components/account/createAccount/UserCreationPage';//eslint-disable-line import/no-named-as-default
import DashboardPage from './components/dashboard/DashboardPage'; //eslint-disable-line import/no-named-as-default
import EstablishmentManagementPage from './components/establishment/establishmentManagement/EstablishmentManagementPage';//eslint-disable-line import/no-named-as-default
import EstablishmentPage from './components/establishment/singleEstablishment/EstablishmentPage';
import SubmissionPage from './components/establishment/singleEstablishment/SubmissionPage';
import PageNotFoundPage from './components/common/PageNotFoundPage';
import PageForbidden from './components/common/PageForbidden';
import EstablishmentDashboardPage from './components/establishment/establishmentsDashboard/EstablishmentsDashboardPage';
import InjurySummaryPage from './components/injurySummary/InjurySummaryManagement/InjurySummaryPage'; //eslint-disable-line import/no-named-as-default
import CaseDataPage from './components/caseData/CaseDataManagement/CaseDataPage';
import CaseDatasDashboardPage from './components/caseData/CaseDataManagement/CaseDatasDashboardPage';
import FileUploadPage from './components/fileUpload/FileUploadPage';//eslint-disable-line import/no-named-as-default
import CaseDataFileUploadPage from './components/fileUpload/CaseDataFileUploadPage';//eslint-disable-line import/no-named-as-default
import ForgotPasswordPage from './components/authentication/ForgotPassword/ForgotPasswordPage';
import requireAuth from './components/authentication/Authentication';
import ProfileManagementPage from './components/account/manageAccount/ProfileManagementPage'; //eslint-disable-line import/no-named-as-default
import HelpRequestPage from './components/helpRequest/HelpRequestPage'; //eslint-disable-line import/no-named-as-default
import HelpRequestPageConfirmation from './components/helpRequest/HelpRequestPageConfirmation'; //eslint-disable-line import/no-named-as-default
import BulkTransferPage from './components/bulkTransfer/BulkTransferPage';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={LoginPage}/>
    <Route
      path={PathConstants.pathToHome}
      component={requireAuth(DashboardPage)}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage}
      component={requireAuth(EstablishmentDashboardPage)}/>
    <Route
      path={PathConstants.pathToCreateEstablishmentPage}
      component={requireAuth(EstablishmentManagementPage)}/>
    <Route
      path={PathConstants.pathToLogin}
      component={LoginPage}/>
    <Route
      path={PathConstants.pathToBulkTransferPage}
      component={requireAuth(BulkTransferPage)}/>
    <Route
      path={PathConstants.pathToLoginWithPasswordReset}
      component={LoginPage}/>
    <Route
      path={PathConstants.pathToForgotPassword}
      component={ForgotPasswordPage}/>
    <Route
      path={PathConstants.pathToCreateAccount}
      component={UserCreationPage}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage
        + '/:id' +
        PathConstants.pathToEditEstablishmentPage}
      component={requireAuth(EstablishmentManagementPage)}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage + '/:id'}
      component={requireAuth(EstablishmentPage)}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage
        + '/:establishmentId'
        + PathConstants.pathToSubmissionPage + '/:submissionId'}
      component={requireAuth(SubmissionPage)}/>
    <Route
      path={PathConstants.pathToFileUploadForm}
      component={requireAuth(FileUploadPage)}/>
    <Route
      path={PathConstants.pathToCaseDataFileUploadForm}
      component={requireAuth(CaseDataFileUploadPage)}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage
        + '/:establishmentId'
        + PathConstants.pathToInjurySummaryFormPageAdd}
      component={requireAuth(InjurySummaryPage)}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage
        + '/:establishmentId'
        + PathConstants.pathToInjurySummaryFormPageEdit
        + '/:injurySummaryFormId'}
      component={requireAuth(InjurySummaryPage)}/>
    <Route
      path={PathConstants.accountPageBase+'/:extension(/:extension2)'}
      component={requireAuth(ProfileManagementPage)}/>
    <Route
      path={PathConstants.pathToHelpRequest}
      component={HelpRequestPage}/>
    <Route 
      path={PathConstants.pathToHelpRequestConfirm}
      component={HelpRequestPageConfirmation}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage
        + '/:establishmentId'
        + PathConstants.pathToCaseDataFormPageAdd}
      component={requireAuth(CaseDataPage)}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage
        + '/:establishmentId'
        + PathConstants.pathToCaseDataDashboardPage}
      component={requireAuth(CaseDatasDashboardPage)}/>
    <Route
      path={PathConstants.pathToEstablishmentsDashboardPage
        + '/:establishmentId'
        + PathConstants.pathToCaseDataFormPageEdit
        + '/:caseDataFormId'}
      component={requireAuth(CaseDataPage)}/>
    <Route path={PathConstants.pathToAccessDenied} component={PageForbidden}/>
    <Route path="/*" component={PageNotFoundPage}/>
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/